<template>
    <div class="float-left">
        <i
            class="fa fa-pencil-square-o fa-lg icon-button"
            title="Dados da Despesa"
            @click.stop="abrirModal()">
        </i>

        <b-modal
            id="modalPrestacaoFinal"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            @close="verificarFechar()">
            <div slot="modal-title">
                Dados da Despesa
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0">
            </app-erros-box>

            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="idPrestacaoContasMensal">Prestação Mensal</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="prestacaoMensal.idPrestacaoContasMensal"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtCompetencia">Competência</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="prestacaoMensal.dtCompetencia"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtPrestacao">Data Prestação</label>
                            <b-input-group>
                                <b-form-input
                                    id="dtPrestacao"
                                    type="text"
                                    v-model="prestacaoMensal.dtPrestacao"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuTotalGasto">Total Despesas</label>
                            <b-input-group>
                                <money
                                    id="nuTotalGasto"
                                    v-model="this.prestacaoMensal.nuTotalGasto"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback>Total Despesas é obrigatória</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuTotalRendimentos">Total Rendimentos</label>
                            <b-input-group>
                                <money
                                    id="nuTotalRendimentos"
                                    v-model="this.prestacaoMensal.nuTotalRendimentos"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback>Total Rendimentos é obrigatório</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuReceitasDiversas">Receitas Diversas</label>
                            <b-input-group>
                                <money
                                    id="nuReceitasDiversas"
                                    v-model="this.prestacaoMensal.nuReceitasDiversas"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback>Receitas Diversas é obrigatória</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5">
                                    Lançamentos
                                </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    idTabela="tblPrestacaoFinal"
                                    :itens="prestacoesFinais"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false">
                                    <template slot="botoes">
                                        <b-button-group class="float-right" v-if="permiteCadastrarPrestacaoFinal">
                                            <btn-inserir-prestacao-conta-final-lancamento
                                                :convenio="convenio"
                                                :idPrestacaoMensal="idPrestacaoMensal"
                                                class="mr-2"
                                                @atualizarLista="obterPrestacaoMensal()"
                                                :dataServicos="dataServicos"
                                                v-if="prestacaoMensal.lancamentosLiberados">
                                            </btn-inserir-prestacao-conta-final-lancamento>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span class="text-danger float-left mr-1" v-if="permiteExcluirPrestacaoFinal">
                                            <b-button-group class="float-right">
                                                <btn-excluir-prestacao-contas-final-lancamento
                                                    :convenio="convenio"
                                                    :prestacaoContasFinalLancamento="data"
                                                    @atualizarLista="obterPrestacaoMensal()"
                                                    :dataServicos="dataServicos"
                                                    v-if="data.codSituacao != 3 && data.codSituacao != 1 && prestacaoMensal.lancamentosLiberados">
                                                </btn-excluir-prestacao-contas-final-lancamento>
                                            </b-button-group>
                                        </span>
                                        <span v-if="permiteAtualizarPrestacaoFinal">
                                                <btn-atualizar-prestacao-contas-final-lancamento
                                                    :convenio="convenio"
                                                    :idPrestacaoMensal="idPrestacaoMensal"
                                                    :prestacaoContasFinalLancamento="data"
                                                    class="mr-2"
                                                    @atualizarLista="obterPrestacaoMensal()"
                                                    :dataServicos="dataServicos"
                                                    v-if="data.codSituacao != 3 && data.codSituacao != 1 && prestacaoMensal.lancamentosLiberados">
                                                </btn-atualizar-prestacao-contas-final-lancamento>
                                        </span>
                                        <span class="text-primary float-left mr-1" v-if="permiteAcessarDocumentos">
                                            <documentos
                                                :convenio="convenio"
                                                :dataServicos="dataServicos"
                                                :prestacaoFinal="data"
                                                class="mr-2"
                                                :permiteCadastrarDocumentos="permiteCadastrarDocumentos"
                                                :permiteExcluirDocumentos="permiteExcluirDocumentos">
                                            </documentos>
                                        </span>
                                        <span
                                            class="text-danger float-left mr-1"
                                            v-if="permiteExcluirJustificarPrestacaoMensal">
                                            <i
                                                class="fa fa-exclamation-circle fa-lg icon-button"
                                                title="Justificativa"
                                                v-if="data.codSituacao == 3 && convenio.idSituacaoConvenio != 9"
                                                @click.stop="mostrarJustificativa(data.justificativaGlosar)"
                                            ></i>
                                        </span>
                                    </template>
                                    <template slot="acao" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.acaoConvenio != null ? data.acaoConvenio.descricao : null }}
                                        </p>
                                    </template>
                                    <template slot="nuValor" slot-scope="data">
                                        <p class="text-right m-0 text-nowrap">
                                            {{ data.nuValor | currency }}
                                        </p>
                                    </template>
                                    <template slot="dtEmissao" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.dtEmissao ? $moment(data.dtEmissao).format('DD/MM/YYYY') : null }}
                                        </p>
                                    </template>
                                    <template slot="dtPagamento" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.dtPagamento ? $moment(data.dtPagamento).format('DD/MM/YYYY') : null }}
                                        </p>
                                    </template>
                                    <template slot="situacao" slot-scope="data">
                                        <app-status
                                            :status="data.situacao.toUpperCase()"
                                        ></app-status>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>

        </b-modal>
    </div>
</template>

<script>
    import Documentos from './ConvenioDadosDespesaDocumentos'
    import BtnInserirPrestacaoContaFinalLancamento from '../cadastros/BtnInserirPrestacaoContaFinalLancamento'
    import BtnAtualizarPrestacaoContasFinalLancamento from '../cadastros/BtnAtualizarPrestacaoContasFinalLancamento'
    import BtnExcluirPrestacaoContasFinalLancamento from '../cadastros/BtnExcluirPrestacaoContasFinalLancamento'

    export default {
        props: {
            convenio: {
                type: Object,
                default: () => ({})
            },
            idPrestacaoMensal: {
                type: Number,
                default: 0
            },
            dataServicos: {
                type: Object
            },
            permiteCadastrarPrestacaoFinal: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirPrestacaoFinal: {
                type: Boolean,
                default: () => false
            },
            permiteAtualizarPrestacaoFinal: {
                type: Boolean,
                default: () => false
            },  
            permiteAcessarDocumentos: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirJustificarPrestacaoMensal: {
                type: Boolean,
                default: () => false
            },
            permiteCadastrarDocumentos: {
                type: Boolean,
                default: () => false
            },
            permiteExcluirDocumentos: {
                type: Boolean,
                default: () => false
            }
        },

        components: {
            BtnInserirPrestacaoContaFinalLancamento,
            Documentos,
            BtnExcluirPrestacaoContasFinalLancamento,
            BtnAtualizarPrestacaoContasFinalLancamento,
        },

        data() {
            return {
                mostrarModal: false,
                itensPorPagina: 5,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                erros: [],
                prestacaoMensal: {},
                prestacoesFinais: [],
                campos: [
                    {
                        key: 'tipoPrestacaoContas',
                        label: 'Tipo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acaoConvenio.descricao',
                        label: 'Ação',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'naturezaDespesa.descricaoCompleta',
                        label: 'Natureza',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'dtEmissao',
                        label: 'Emissão',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcFavorecido',
                        label: 'Favorecido',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcDocumento',
                        label: 'Documento',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'nuValor',
                        label: 'Valor',
                        filterable: true,
                        sortable: true,
                        tdClass: 'text-nowrap'
                    },
                    {
                        key: 'dtPagamento',
                        label: 'Pagamento',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'lancamentoBancario',
                        label: 'Lançamento Bancário',
                        filterable: true,
                        sortable: true,
                        tdClass: 'text-nowrap'
                    },
                    {
                        key: 'situacao',
                        label: 'Situação',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acoes',
                        label: ''
                    }
                ],
            }
        },

        methods: {
            abrirModal() {
                this.mostrarModal = true;
                this.obterPrestacaoMensal();
            },

            fecharModal() {
                this.mostrarModal = false;
                this.$emit('atualizarLista');
            },

            obterPrestacaoMensal(){
                if (this.idPrestacaoMensal > 0){
                    this.$store.dispatch('addRequest')
                    this.dataServicos.ObterPrestacaoMensal(this.idPrestacaoMensal).then(
                        response => {
                            if (response) {
                                if (response.success) {
                                    this.prestacaoMensal = response.data
                                    this.prestacaoMensal.dtCompetencia = this.$moment(this.prestacaoMensal.dtCompetencia, 'YYYY-MM-DD').format('MM/YYYY')
                                    this.prestacaoMensal.dtPrestacao = this.$moment(this.prestacaoMensal.dtPrestacao, 'YYYY-MM-DD').format('DD/MM/YYYY')
                                    this.prestacoesFinais = response.data.prestacoesContasFinal;
                                } else {
                                    this.erros = response.errors
                                }
                            }
                            this.$store.dispatch('removeRequest')
                        }
                    )
                }
            },

            mostrarJustificativa(justificativa) {
                this.$swal({
                    title: 'Justificativa',
                    html: `<b>${justificativa}</b>`,
                    icon: 'warning',
                })            
            },

            excluir(id){
                this.$store.dispatch('addRequest')
                this.dataServicos.ExcluirPrestacaoFinal(id)
                .then(
                    response => {
                        if (response) {
                            this.obterPrestacaoMensal();
                        }
                    }
                )
                this.$store.dispatch('removeRequest')
            },
        },
    }
</script>
